/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".colorgreen[_ngcontent-%COMP%]{color:#67b962}.colorred[_ngcontent-%COMP%]{color:#c10000}.colorblue[_ngcontent-%COMP%]{color:#369bbb}.colororange[_ngcontent-%COMP%]{color:#c96705}.colormain[_ngcontent-%COMP%]{color:#486aa3}.coloryellow[_ngcontent-%COMP%]{color:#fab700}\n/*# sourceMappingURL=pending.component.css.map*/"];
export { styles as styles };
